module.exports = __webpack_public_path__ + "pc/img/ico-e-red.8eb34264.svg";